module.exports = __webpack_public_path__ + "img/c4abs.45de5752.png";